import { API_CONFIG } from "../../shared/api/config";
import composeRequest from '../../shared/api/core';

const BASE_URL = API_CONFIG.API_BASE_PATH;

export const API_URLS = {
  labelerTemplatesUrl: BASE_URL + 'labeler/templates/',
  labelerZPLPreviewUrl: BASE_URL + 'labeler/templates/preview/',
  labelerSummaryDataUrl: BASE_URL + 'labeler/templates/summary/'
};


export const getTemplatesByPage = (
  page: number,
  pageSize: number,
  searchTerm: string | null,
  businessId: number | string,
  orderBy: string | number,
  includeInactive?: boolean
) => {
  let URL = `${API_URLS.labelerTemplatesUrl}?business_ids=${businessId}&page=${page}&page_size=${pageSize}`;
  if (searchTerm) {
    URL += `&search=${encodeURIComponent(searchTerm)}`;
  }
  if (orderBy) {
    URL += `&orderBy=${orderBy}`;
  }
  if (includeInactive) {
    URL += `&include_inactive=1`;
  }
  return composeRequest(URL, 'GET', null);
};

export const getTemplateById = (id: number | string) => {
  const URL = API_URLS.labelerTemplatesUrl + id + '/';
  return composeRequest(URL, 'GET', null);
};

export const updateTemplate = (id: number | string, data: object) => {
  const URL = API_URLS.labelerTemplatesUrl + id + '/';
  return composeRequest(URL, 'PATCH', JSON.stringify(data), 'application/json');
};

export const deleteTemplate = (data: any) => {
  const URL = API_URLS.labelerTemplatesUrl + data.id + '/';
  return composeRequest(URL, 'DELETE', null);
};